export function StarRating({ rating, size = "md" }: { rating: number; size?: "sm" | "md" | "lg" }) {
  const rounded = Math.max(1, Math.min(5, Math.round(rating)));
  return (
    <span
      className={`star-rating size-${size}`}
      role="img"
      aria-label={`${rating} de 5 estrellas`}
      title={`${rating} ★`}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star-char ${star <= rounded ? "filled" : "empty"}`}
          aria-hidden="true"
        >
          ★
        </span>
      ))}
    </span>
  );
}
